import { Container, Grid, Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useRouter } from 'next/router';
import { createVirtualLink } from '../../../util/createVirtualLink';
import styles from './styles';

const InfoBanner = ({
  title,
  titleFontColor,
  description,
  descriptionFontColor,
  number,
  CTAtext,
  CTATextColor,
  CTABackgroundColor,
  isCTAVisible,
  CTAAriaLabel,
  CTALink,
}) => {
  const router = useRouter();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));

  const handleContact = () => {
    router.push(`tel:${number}`);
  };
  const handleLink = () => {
    createVirtualLink(CTALink);
  };

  return (
    <Container maxWidth='lg'>
      <Grid item xs={12} sm={8.5} md={6} sx={styles(theme).infoBannerContainer}>
        <Box sx={styles(theme).infoBannerTitleContainer}>
          <Typography
            component='h2'
            variant='h2'
            color={titleFontColor}
            sx={styles(theme).infoBannerTitle}
          >
            {title}
          </Typography>
          <Typography
            component='p'
            variant='body1'
            color={descriptionFontColor}
            sx={styles(theme).infoBannerDescription}
          >
            {description}{' '}
            {!sm && (
              <Typography component='span' variant='body1' color={descriptionFontColor}>
                {number?.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3')}
              </Typography>
            )}
          </Typography>
          {sm && (
            <Typography component='p' variant='body1' color={descriptionFontColor}>
              {' '}
              {number?.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3')}
            </Typography>
          )}
          {isCTAVisible && (
            <Button
              variant='buttonSmall'
              aria-label={CTAAriaLabel}
              sx={{
                ...styles(theme).infoSubmitCTA,
                background: CTABackgroundColor,
                borderColor: CTABackgroundColor,
              }}
              onClick={CTALink ? handleLink : handleContact}
            >
              <Typography
                variant='subtitle1'
                sx={{ ...styles(theme).infoBannerButtonText, color: CTATextColor }}
              >
                {CTAtext}
              </Typography>
            </Button>
          )}
        </Box>
      </Grid>
    </Container>
  );
};

export default InfoBanner;
